import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const seoMeta = {
  home: {
    title: "中物鉴智｜科技成果评价、技术评估与概念验证服务",
    description: "中物鉴智（成都）科技成果评价有限公司提供科技成果评价、技术评估、概念验证、项目验收、奖励培育等专业第三方评价服务。",
    keywords: "中物鉴智,科技成果评价,成果评价,技术评估,概念验证,项目验收,科技奖励培育",
    canonical: "https://zwjz.org.cn/",
  },
  caseCenter: {
    title: "评价案例｜中物鉴智科技成果评价服务",
    description: "查看中物鉴智科技成果评价案例，了解成果评价、技术评估、项目验收、奖励培育等服务实践。",
    keywords: "评价案例,科技成果评价案例,成果评价服务,中物鉴智",
    canonical: "https://zwjz.org.cn/index/caseCenter",
  },
  newsCenter: {
    title: "报告查询｜中物鉴智科技成果评价报告查询",
    description: "中物鉴智提供科技成果评价报告查询服务，可通过报告编号查询评价报告相关信息。",
    keywords: "报告查询,评价报告查询,科技成果评价报告,中物鉴智",
    canonical: "https://zwjz.org.cn/index/newsCenter",
  },
  aboutUs: {
    title: "关于我们｜中物鉴智（成都）科技成果评价有限公司",
    description: "了解中物鉴智（成都）科技成果评价有限公司的机构介绍、服务能力和科技成果评价业务。",
    keywords: "关于中物鉴智,科技成果评价公司,技术评估机构,成果评价机构",
    canonical: "https://zwjz.org.cn/index/aboutUs",
  },
  notification: {
    title: "通知公告｜中物鉴智科技成果评价资讯",
    description: "查看中物鉴智科技成果评价相关通知公告、业务动态和公开信息。",
    keywords: "通知公告,中物鉴智公告,科技成果评价资讯",
    canonical: "https://zwjz.org.cn/index/notification",
  },
};

const routes = [
  {
    path: "/",
    component: () => import("../views/Index.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/Home/Home.vue"),
        meta: seoMeta.home,
      },
      {
        path: "index/home",
        component: () => import("../views/Home/Home.vue"),
        meta: seoMeta.home,
      },
      {
        path: "index/newsCenter",
        component: () => import("../views/NewsCenter/index.vue"),
        meta: seoMeta.newsCenter,
      },
      {
        path: "index/joinUs",
        component: () => import("../views/JoinUs/index.vue"),
      },
      {
        path: "index/caseCenter",
        component: () => import("../views/CaseCenter/index.vue"),
        meta: seoMeta.caseCenter,
      },
      {
        path: "index/aboutUs",
        component: () => import("../views/AboutUs/index.vue"),
        meta: seoMeta.aboutUs,
      },
      {
        path: "index/Register",
        component: () => import("../views/Register/index.vue"),
      },
      {
        path: "index/notification",
        component: () => import("../views/Notification/index.vue"),
        meta: seoMeta.notification,
      },
      {
        path: "index/notification/deils",
        component: () => import("../views/Notification/deils.vue"),
        meta: seoMeta.notification,
      },
    ],
  }
];
export default new VueRouter({
  mode:'history',
  routes,
});
